export default __webpack_public_path__ + "static/media/bannerRaceweekAustria_330x330.04717e15.webp";